<template>
    <div class="Consultantcertification">
        <div class="header">
            <el-row>
                <el-col :span="6">
                    <label class="headerlabel">综合搜索</label>
                    <el-input v-model="param.name" placeholder="请输入账号/姓名搜索" class="autowidth" clearable></el-input>
                </el-col>
                <el-col :span="6">
                    <label class="headerlabel">审批状态</label>
                    <el-select v-model="param.state" placeholder="请选择" filterable  class="autowidth" clearable >
                        <el-option label="待审核" :value="0"></el-option>
                        <el-option label="审核通过" :value="2"></el-option>
                        <el-option label="审核不通过" :value="-1"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="6">
                    <el-button type="primary" @click="init">筛选</el-button>
                    <el-button @click="reset">重置条件</el-button>
                </el-col>
            </el-row>
        </div>

        <main class="MainContent">
            <el-table
            :data="ConsultantcertificationData"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            style="width: 100%;margin-bottom: 20px;">
                <el-table-column label="序号">
                    <template slot-scope="scope">
                        {{ (param.pageIndex - 1) * 10 + scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="UserID" label="账号"></el-table-column>
                <el-table-column prop="RealName" label="姓名"></el-table-column>
                <el-table-column prop="Sex" label="性别"></el-table-column>
                <el-table-column prop="CreatedDate" label="申请时间"></el-table-column>
                <el-table-column prop="ZAppCheckState" label="初审状态">
                    <template slot-scope="scope">
                        <div v-if="scope.row.ZAppCheckState==0">待审核</div>
                        <div v-else-if="scope.row.ZAppCheckState==2">审核通过</div>
                        <div v-else-if="scope.row.ZAppCheckState==-1">审核不通过</div>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" @click="LookDetail(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
            :hide-on-single-page=true
            @current-change="handleinitialization"
            :current-page.sync="param.pageIndex"
            :page-size="param.pageSize"
            layout="total, prev, pager, next"
            :total="param.PageTotal">
        </el-pagination>
    </main>

    <el-dialog
        title="审批"
        :visible.sync="dialogVisible"
         width="70%"
        center
        :before-close="handleClose">
        <div class="dialogform">
            <p class="title">基本信息</p>
            <el-descriptions :column="3" class="info" border>
                <el-descriptions-item label="姓名">{{BasicInfo.RealName}}</el-descriptions-item>
                <el-descriptions-item label="性别">{{BasicInfo.Sex}}</el-descriptions-item>
                <el-descriptions-item label="出生日期">{{BasicInfo.BirthDate}}</el-descriptions-item>
                <el-descriptions-item label="现居住城市">{{BasicInfo.ResidenceAddress}}</el-descriptions-item>
                <el-descriptions-item label="手机号码">{{BasicInfo.Mobile}}</el-descriptions-item>
                <el-descriptions-item label="邮箱地址">{{BasicInfo.eMail}}</el-descriptions-item>
                <el-descriptions-item label="证件信息">
                    <el-image v-for="item in BasicInfo.Images" :src="item.Url" class="Consultantitemsimg" fit="cover"></el-image>
                </el-descriptions-item>
            </el-descriptions>

            <p class="title">教育经历</p>
            <el-descriptions :column="3" class="Consultantitems" v-for="item in StudyInfo">
                <el-descriptions-item label="学校名称">{{item.School}}</el-descriptions-item>
                <el-descriptions-item label="专业">{{item.MajorCourses}}</el-descriptions-item>
                <el-descriptions-item label="学历">{{item.Degree}}</el-descriptions-item>
                <el-descriptions-item label="入学时间">{{item.StartDate}}</el-descriptions-item>
                <el-descriptions-item label="毕业时间">{{item.EndDate}}</el-descriptions-item>
                <el-descriptions-item label="毕业证书">
                    <el-image v-for="item in StudyInfo.Images" :src="item.Url" class="Consultantitemsimg" fit="cover"></el-image>
                </el-descriptions-item>
            </el-descriptions>

            <el-descriptions :column="3" class="Consultantitems" v-for="item in TrainingInfo">
                <el-descriptions-item label="机构名称">{{item.TrainingInstitutions}}</el-descriptions-item>
                <el-descriptions-item label="培训师">{{item.TrainerInfo}}</el-descriptions-item>
                <el-descriptions-item label="培训时长">{{item.TrainingTime}}</el-descriptions-item>
                <el-descriptions-item label="开始时间">{{item.TrainingStartDate}}</el-descriptions-item>
                <el-descriptions-item label="结束时间">{{item.TrainingEndDate}}</el-descriptions-item>
                <el-descriptions-item label="内容简介">{{item.TrainingSubject}}</el-descriptions-item>
                <el-descriptions-item label="证件信息">
                    <el-image v-for="item in TrainingInfo.Images" :src="item.Url" class="Consultantitemsimg" fit="cover"></el-image>
                </el-descriptions-item>
            </el-descriptions>

            <p class="title">专业资质证明</p>
            <el-descriptions :column="3" class="Consultantitems" v-for="item in QualificationInfo">
                <el-descriptions-item label="资质等级名称">{{item.QualificationLevelName}}</el-descriptions-item>
                <el-descriptions-item label="证件信息">
                    <el-image v-for="item in QualificationInfo.Images" :src="item.Url" class="Consultantitemsimg" fit="cover"></el-image>
                </el-descriptions-item>
            </el-descriptions>

            <p class="title">咨询实践</p>
            <el-descriptions :column="3" class="Consultantitems" v-for="item in ConsultingInfo">
                <el-descriptions-item label="咨询地点">{{item.Address}}</el-descriptions-item>
                <el-descriptions-item label="咨询时长">{{item.TimeLength}}</el-descriptions-item>
                <el-descriptions-item label="联系人">{{item.VisitorName}}</el-descriptions-item>
                <el-descriptions-item label="联系电话">{{item.VisitorPhone}}</el-descriptions-item>
                <el-descriptions-item label="补充信息">{{item.Remark}}</el-descriptions-item>
                <el-descriptions-item label="证件信息">
                    <el-image v-for="item in ConsultingInfo.Images" :src="item.Url" class="Consultantitemsimg" fit="cover"></el-image>
                </el-descriptions-item>
            </el-descriptions>

            <p class="title">督导经历</p>
            <el-descriptions :column="3" class="Consultantitems" v-for="item in SupervisionInfo">
                <el-descriptions-item label="督导姓名">{{item.SupervisionName}}</el-descriptions-item>
                <el-descriptions-item label="督导取向">{{item.SupervisionOrientation}}</el-descriptions-item>
                <el-descriptions-item label="督导类型">{{item.SupervisionType}}</el-descriptions-item>
                <el-descriptions-item label="督导时长">{{item.TimeLength}}</el-descriptions-item>
                <el-descriptions-item label="证件信息">
                    <el-image v-for="item in SupervisionInfo.Images" :src="item.Url" class="Consultantitemsimg" fit="cover"></el-image>
                </el-descriptions-item>
            </el-descriptions>
        </div>

        <div style="text-align: center;margin: 20px 0 10px;">
            <el-button @click="handleClose">取消</el-button>
            <el-button type="primary" @click="agree(-1)" v-if="ZAppCheckState==0" :loading="refuseload" >拒绝</el-button>
            <el-button type="primary" @click="agree(2)" v-if="ZAppCheckState==0" :loading="agreeload">同意</el-button>
        </div>
    </el-dialog>


    </div>
</template>
<script>
export default{
    data() {
        return {
            loading:false,
            dialogVisible:false,
            param:{
                pageIndex:1,
                pageSize:10,
                PageTotal:0,
                name:'',
                state:''
            },
            ConsultantcertificationData:[],
            BasicInfo:'',
            StudyInfo:[],
            TrainingInfo:[],
            QualificationInfo:[],
            ConsultingInfo:[],
            SupervisionInfo:[],
            ReportInfo:[],
            RecommandInfo:[],
            ZAppCheckState:0,
            examineparams:{
                UserID:'',
                CheckState:'',
                CheckRemark:''
            },
            refuseload:false,
            agreeload:false
        }
    },
    mounted() {
        this.init();
    },
    methods:{
        init(){
            this.loading=true;
            this.$Http_Post('/consultToexamine/PostToExamineList',this.param).then(res=>{
                this.loading=false;
                if(res.Code==0 || res.Code==200){
                    this.param.PageTotal=res.Counts;
                    this.ConsultantcertificationData=res.Data;
                }else{
                    this.$message.error(res.Message);
                }
            })
        },

        handleClose(){
            this.dialogVisible=false;
            this.init();
        },
        handleinitialization(val){
            this.param.pageIndex=val;
            this.init();
        },
        reset(){
            this.param=this.$options.data().param;
            this.init();
        },

        LookDetail(val){
            this.examineparams.UserID=val.UserID;
            this.ZAppCheckState=val.ZAppCheckState;
            this.$Http_Post('/api/Counselor/PostCounselorInfoPreview',{UserID:val.UserID}).then(res=>{
                if(res.Code==0 || res.Code==200){
                    this.dialogVisible=true;
                    this.BasicInfo=res.Data.BasicInfo[0];
                    this.StudyInfo=res.Data.StudyInfo;
                    this.TrainingInfo=res.Data.TrainingInfo;
                    this.QualificationInfo=res.Data.QualificationInfo;
                    this.ConsultingInfo=res.Data.ConsultingInfo;
                    this.SupervisionInfo=res.Data.SupervisionInfo;
                    this.ReportInfo=res.Data.ReportInfo;
                    this.RecommandInfo=res.Data.RecommandInfo;
                }else{
                    this.$message.error(res.Message);
                }
            })
        },
        agree(val){
            this.agreeload=val==2?true:false;
            this.refuseload=val==-1?true:false;
            
            this.examineparams.CheckState=val;
            this.$Http_Post('/consultToexamine/PostToExamine',this.examineparams).then(res=>{
                if(res.Code==0 || res.Code==200){
                    this.$message.success(res.Message);
                    this.handleinitialization(0);
                    this.agreeload=false;
                    this.refuseload=false;
                    this.dialogVisible=false;
                }else{
                    this.$message.error(res.Message);
                }
            })
        }



    },
}
</script>
<style>
.Consultantcertification .header{background: #fff;padding:20px;}
.Consultantcertification .headerlabel{width:90px;display: inline-block;}
.Consultantcertification .autowidth{width: 240px;}
.Consultantcertification .dialogform .title{margin-top: 30px;font-size:16px;font-weight: bold;}
.Consultantcertification .Consultantitems{margin-top: 10px;}
.Consultantcertification .info{margin-top: 10px;}
.Consultantcertification .Consultantitems td{border: none!important;}
.Consultantcertification .Consultantitemsimg{width: 150px;margin:0 5px;height: 100px;}
</style>